export default {
  props: {
    image: {
      type: [Array, Object],
    },
    title: {
      type: String,
      required: true,
    },
    buttons: {
      type: [Array, Object],
    },
    cards: {
      type: [Array, Object],
    },
  },
}
